import type { ReactNode } from "react";

export type TagTone = "ink" | "primary" | "accent" | "rule" | "ok" | "strike" | "solid";

export interface TagProps {
  children: ReactNode;
  tone?: TagTone;
  className?: string;
}

const TONE_CLASS: Record<TagTone, string> = {
  ink: "border-[var(--secondary)] text-[var(--secondary)]",
  primary: "border-[var(--primary)] text-[var(--primary)]",
  accent: "border-[var(--accent)] text-[var(--accent-strong)]",
  rule: "border-[var(--rule)] text-[var(--ink-3)]",
  ok: "border-[var(--ok)] text-[var(--ok)]",
  strike: "border-[var(--strike)] text-[var(--strike)]",
  solid: "bg-[var(--primary)] text-[var(--neutral-content)] border-[var(--primary)]",
};

export function Tag({ children, tone = "ink", className = "" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 h-5 border text-[10.5px] font-medium tracking-[0.06em] uppercase mono ${TONE_CLASS[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
